import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token: string = localStorage.getItem('token')

    if (token && !request.url.includes('/lang/')) {
      const cloneRequest = (request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      }))

      return next.handle(cloneRequest)
    } else {
      return next.handle(request)
    }
  }
}
